export class TaxGroup {
  TaxGroupId: string;
  FederalTaxApply: boolean;
  FederalTaxName: string;
  FederalTaxNumber: string;
  FederalTaxRate: number;
  ProvincialTaxApply: boolean;
  ProvincialTaxName: string;
  ProvincialTaxNumber: string;
  ProvincialTaxRate: number;
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/models/tax-group.ts